import { Item__Atividades, Item__UnidadeMedida } from "../../../../../../../../services/atividades/GET";
import { Item__EquipeCliente } from "../../../../../../../../services/Equipe/GET";
import { dummy_tipos_uso, extrairUnidade } from "../../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { converterQuantidade } from "../../../../meta/obter_dados";

interface Insumo {
    quantidade: number | null;
}

interface Andamento {
    cod_usuario: number | null;
    area: number | null;
    create_time?: string | null;
    insumos?: Insumo[];
}

interface ListarAtividadeFlat {
    descricao: string | null;
    cod_usuario: number | null;
    area: number | null;
    data: string | null;
    quantidade: number | null;
    cod_medida: number | null;
    nome_medida: string | null;
    nome_operador_executada: string | null;
    nome_operadores_planejada: string[];
    dosagem: string | number;
    tipo_uso: string;
    calculo_dosagem: string | null;
}

export function estruturaListarInsumos(
    atividades_com_o_insumo: any[],
    data_unidades_medida: Item__UnidadeMedida[],
    data_equipe_cliente: Item__EquipeCliente[],
): ListarAtividadeFlat[] {

    function obterNomeOperador(cod_usuario: number | null): string | null {
        const operador = (data_equipe_cliente ?? []).find(eq => eq?.cod_func === cod_usuario);
        return operador ? operador.usuario_nome ?? null : null;
    }
    function obterNomeMedida(cod_medida: number, cod_tipo?: number, calculo_dosagem?: string) {
        if (cod_tipo === 8) {
            let unidade_calculo_dosagem = extrairUnidade(calculo_dosagem)
            return unidade_calculo_dosagem
        };
        return (data_unidades_medida ?? []).find(i => i.cod === cod_medida)?.nome ?? '?';
    }

    let estrutura = (atividades_com_o_insumo ?? []).map((item) => {
        let unidade_medida_nome = item?.cod_tipo === 8 ? item?.medida_inoculante : obterNomeMedida(item?.cod_medida)

        return {
            descricao: item.nome_atividade,
            nome_operador_executada: obterNomeOperador(item?.cod_usuario) ?? null,
            nome_operadores_planejada: (item?.operadores_planejada ?? []).map(item => obterNomeOperador(item.cod_usuario)) ?? null,
            area: item?.area_andamento,
            data: item?.data_inicio_atividade,
            quantidade: converterQuantidade(item?.quantidade, unidade_medida_nome).quantidade_convertida,
            nome_medida: converterQuantidade(item?.quantidade, unidade_medida_nome).medida_convertida,
            cod_medida: 0,
            cod_usuario: 0,
            dosagem: item?.dosagem + ' ' + obterNomeMedida(item.cod_medida, item?.cod_tipo, item.calculo_dosagem),
            tipo_uso: dummy_tipos_uso?.find(i => i.cod === item?.cod_tipo)?.nome ?? '',
            calculo_dosagem: item?.calculo_dosagem ?? null,
        }
    })

    return estrutura ?? [];
}
